import { addEventListener } from '@/assets/js/ulits.js'
import { throttle } from 'underscore'
let EVENT = null

/**
 * 计算高度并回调
 * @param {HTMLElement} el 当前绑定节点元素
 * @param {String} arg 元素单行高度
 * @param {Function} callBack 回调函数
 */
const computedHeight = throttle((el, arg, callBack) => {
    let height = el.offsetHeight
    typeof callBack === 'function' && callBack(height > arg)
}, 500)


const install = Vue => {
    if (install.installed) return
    install.installed = true
    Vue.directive('row', {
        inserted (el, binding) {
            let {
                arg,
                value
            } = binding
            computedHeight(el, arg, value)
            EVENT = addEventListener(window, 'resize', () => {
                computedHeight(el, arg, value)
            })
        },
        update(el, binding) {
            let {
                arg,
                value
            } = binding
            computedHeight(el, arg, value)
        },
        unbind() {
            EVENT && EVENT()
        }
    })
}

export default {
    install
}




// WEBPACK FOOTER //
// ./src/plugins/row/index.js